'use client';

import { useState } from 'react';
import PropTypes from 'prop-types';
import QuickEntrySheet from './QuickEntrySheet';
import { price } from '@/lib/homepage/format';

/** "Enter all of tonight's draws": one panel, one question each, one basket. */
export default function EnterTonight({ competitions, when }) {
  const [open, setOpen] = useState(false);
  if (competitions.length < 2) return null;
  const from = competitions.reduce((sum, c) => sum + Number(c.ticketPrice || 0), 0);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="btn-block btn-line">
        Enter all {competitions.length} from {price(from)}
      </button>
      {open && (
        <QuickEntrySheet
          competitions={competitions}
          title={`Enter ${when || 'all the'}\u2019s draws`.replace('all the\u2019s', 'all the')}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}

EnterTonight.propTypes = {
  competitions: PropTypes.array.isRequired,
  when: PropTypes.string,
};
